//Data Reducer types
export const SET_BIN_LABELS = 'SET_BIN_LABELS';
export const SET_BIN_DIVIDERS = 'SET_BIN_DIVIDERS';
export const SET_CHROMA_ISOLINES = 'SET_CHROMA_ISOLINES';
export const SET_REPORT_DATA = 'SET_REPORT_DATA';
export const SET_LIBRARY_DATA = 'SET_LIBRARY_DATA';
export const DELETE_LIBRARY_ITEM = 'DELETE_LIBRARY_ITEM';
export const CLEAR_LIBRARY_DATA = 'CLEAR_LIBRARY_DATA';
export const SET_FULL_REPORT_METADATA = 'SET_FULL_REPORT_METADATA';
export const DELETE_FULL_REPORT_METADATA = 'DELETE_FULL_REPORT_METADATA';
export const SET_LUOX_DATA = 'SET_LUOX_DATA';
export const SET_PASTE_LUOX_DATA = 'SET_PASTE_LUOX_DATA';
export const SET_LUOX_UNITS = 'SET_LUOX_UNITS';
export const SET_GLOBAL_SPINNER = 'SET_GLOBAL_SPINNER';
export const SET_GLOBAL_TOAST = 'SET_GLOBAL_TOAST';
export const SET_EXCEL_UPLOAD_ERRORS = 'SET_EXCEL_UPLOAD_ERRORS';
export const SET_SHOW_EXCEL_UPLOAD_ERRORS = 'SET_SHOW_EXCEL_UPLOAD_ERRORS';
